import { BackendResponseFormat } from "../utils/fetch";
import { BackendError } from "./BackendError";

export class UnprocessableEntityError extends BackendError {
  constructor(responseBody: BackendResponseFormat<unknown> | string) {
    super(422, responseBody);
    this.name = "UnprocessableEntityError";
  }
}
